import { useApi } from "../../../../../service/ApiContext";
import VideoLandingPageClient from "../api/VideoLandingPageClient";
import { QuizData, QuizRequest } from "../response/popQuizResponse";
import Loader, { LocalStorage } from "../../../../../utils/Utils";
interface QuizParams {
  program_id: string;
  course_id: string;
  topic_id: string;
  video_id: string;
}
interface SubmitQuizParams {
  assessment_id: string;
  video_id: string;
}
const PopQuizApiCall = () => {
  const api = useApi();

  const setAuthToken = () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
  };

  const getQuizData = async (params: QuizParams): Promise<QuizData | null> => {
    setAuthToken();

    try {
      Loader.showLoading("Loading...");
      const res = await api.get<QuizData>(
        VideoLandingPageClient.quizData,
        params,
      );
      return res.data; // ✅ Return only the data
    } catch (error) {
      return null; // ✅ Properly return null if there's an error
    } finally {
      Loader.dismissLoading();
    }
  };
  const submitQuizData = async (
    assessment_id: String,
    video_id: String,
    body: QuizRequest,
  ): Promise<QuizData | null> => {
    setAuthToken();
    try {
      Loader.showLoading("Loading...");

      const res = await api.post<QuizData>(
        `${VideoLandingPageClient.submitQuizData}?assessment_id=${assessment_id}&video_id=${video_id}`,
        body,
      );
      return res.data;
    } catch (error) {
      return null;
    } finally {
      Loader.dismissLoading();
    }
  };

  return {
    getQuizData,
    submitQuizData,
  };
};

export default PopQuizApiCall;
